/**
 * WHEN THE CORNER TILE GOES AWAY.
 *
 * The picture-in-picture tile a call collapses into when you navigate elsewhere
 * is not an end screen — it is a CLAIM THAT A CALL IS IN PROGRESS. So it has one
 * rule, and the rule is not "the call ended", because one of the ways a call
 * stops being in progress leaves `endedReason` deliberately null.
 *
 * AN ESCALATION COUNTS AS AN ENDING HERE, and it is the ONE place it does.
 * `useCallLifecycle` sets `escalated` without an `endedReason` on purpose —
 * there is no end screen for a call that turned into a meeting — but the tile
 * is a different question. Without this the person who PRESSED "Move to meeting"
 * carries a tile for a dead call over the top of their own meeting for the rest
 * of the session: `useEscalatedCall` does not move them (they navigate on their
 * own HTTP response), and a merge does not need it at all because `useOpenCall`
 * overwrites the same single-call slot with the surviving call. A meeting is not
 * a call and cannot.
 *
 * A function rather than three booleans inline in an effect because it is a RULE
 * with a history: reverting it to `endedReason !== null` is a one-token edit that
 * typechecks, lints, builds, and makes the dead tile permanent — and the 30-second
 * poll that used to clean it up is disarmed by the same escalation.
 */
export function shouldDropCompactTile(input: {
  /** The surface has collapsed into the corner rather than owning the page. */
  readonly compact: boolean;
  readonly endedReason: string | null;
  readonly escalated: boolean;
}): boolean {
  if (!input.compact) return false;
  return input.endedReason !== null || input.escalated;
}
